import { FlaskConical } from "lucide-react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useAlphaAccess } from "../../hooks/useAlphaAccess";

interface AlphaModeControlProps {
  collapsed?: boolean;
  onNavigate?: () => void;
}

const AlphaModeControl: React.FC<AlphaModeControlProps> = ({
  collapsed = false,
  onNavigate,
}) => {
  const canAccessAlpha = useAlphaAccess();
  const { getUserConfigValue, userConfigLoaded } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (!canAccessAlpha) return null;

  const isActive = location.pathname.startsWith("/alpha");
  const alphaDestination = userConfigLoaded
    && getUserConfigValue("iscustomer") === "true"
    ? "/alpha/dashboard"
    : "/alpha";

  return (
    <button
      type="button"
      aria-pressed={isActive}
      title={collapsed ? "Open Alpha" : undefined}
      onClick={() => {
        onNavigate?.();
        navigate(alphaDestination);
      }}
      className={`w-full flex items-center gap-3 text-xs font-medium rounded-lg border transition-colors ${
        collapsed ? "justify-center px-2 py-2.5" : "px-3 py-2.5"
      } ${
        isActive
          ? "border-rp-amber bg-rp-amber/20 text-white"
          : "border-rp-amber/70 text-white hover:bg-rp-amber/20"
      }`}
    >
      <FlaskConical className="w-5 h-5 shrink-0" aria-hidden="true" />
      {!collapsed && <span>Alpha</span>}
    </button>
  );
};

export default AlphaModeControl;
